var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#1E57EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2485 34.0006H58.694V57.9891L38.2932 57.9886C37.8037 53.3077 37.8032 48.3245 37.8032 43.1416C37.8032 42.4209 38.388 41.8355 39.109 41.8355C42.8816 41.8355 46.9429 39.7926 46.9429 35.3056C46.9429 34.5849 47.5277 34 48.2488 34L48.2485 34.0006ZM80.8907 41.8361C77.1181 41.8361 73.0568 39.7933 73.0568 35.3062C73.0568 34.5856 72.472 34.0001 71.7509 34.0001L61.3054 34.0006V57.9892H81.7062C82.1963 53.3077 82.1968 48.3245 82.1968 43.1421C82.1968 42.421 81.612 41.836 80.891 41.836L80.8907 41.8361ZM58.6936 85.7925V60.6003H38.6292C40.223 71.1191 44.9203 79.9312 58.6936 85.7925ZM61.3047 85.7925C75.0787 79.931 79.7756 71.1193 81.3692 60.6003H61.3047V85.7925Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.92f7fefad0ee4742fb8da3bd58bee93d.svg";
export { ForwardRef as ReactComponent };